import axios from 'axios';
import token from './token';
const CREDENTIAL_PATH = '/schoolcred/file/thirdparty/static';

let clientPromise = null;
let payloadKeyPromise = null;

function b64ToBytes(b64) {
    return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
}

function getPayloadKey() {
    if (!payloadKeyPromise) {
        payloadKeyPromise = crypto.subtle.importKey(
            'raw',
            b64ToBytes(process.env.VUE_APP_OSS_PAYLOAD_KEY),
            'AES-GCM',
            false,
            ['decrypt']
        );
    }
    return payloadKeyPromise;
}

async function decryptPayload({ iv, tag, data }) {
    const key = await getPayloadKey();

    const cipherBytes = b64ToBytes(data);
    const tagBytes = b64ToBytes(tag);
    const combined = new Uint8Array(cipherBytes.length + tagBytes.length);
    combined.set(cipherBytes);
    combined.set(tagBytes, cipherBytes.length);

    const plain = await crypto.subtle.decrypt(
        { name: 'AES-GCM', iv: b64ToBytes(iv) },
        key,
        combined
    );

    return JSON.parse(new TextDecoder().decode(plain));
}

async function fetchOssCredential() {
    const auth = token.getToken();

    let payload;

    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_BASE_URL}${CREDENTIAL_PATH}`,
            {
                timeout: 15000,
                headers: auth?.token
                    ? { Authorization: `Bearer ${auth.token}` }
                    : {},
            }
        );

        payload = response.data;
    } catch (error) {
        const description = error.response?.data?.description;

        throw new Error(description || 'Gagal mengambil kredensial OSS', {
            cause: error,
        });
    }

    return decryptPayload(payload);
}

export default function getOssClient() {
    if (!clientPromise) {
        clientPromise = Promise.all([import('ali-oss'), fetchOssCredential()])
            .then(
                ([{ default: OSS }, cred]) =>
                    new OSS({
                        region: process.env.VUE_APP_OSS_REGION,
                        accessKeyId: cred.accessKeyId,
                        accessKeySecret: cred.accessKeySecret,
                        bucket: process.env.VUE_APP_OSS_BUCKET,
                        secure: true,
                        ...(cred.stsToken && {
                            stsToken: cred.stsToken,
                            refreshSTSToken: fetchOssCredential,
                            refreshSTSTokenInterval: 1800000,
                        }),
                    })
            )
            .catch((error) => {
                clientPromise = null;
                throw error;
            });
    }

    return clientPromise;
}
